export namespace IDisclaimer {
  export type IconType =
    | 'ICON_UNKNOWN'
    | 'INTERNATIONAL'
    | 'CAUTION'
    | 'DOLLAR_SIGN'
    | 'PERCENT_SIGN'
    | 'SHIPMENT_DELIVERED'
    | 'STACK_BILL'
    | 'DIAMOND'
    | 'CALENDAR'
    | 'DOLLAR_SIGN_WITH_CIRCLE_ARROW';

  export enum Icon {
    ICON_UNKNOWN = 'ICON_UNKNOWN',
    INTERNATIONAL = 'INTERNATIONAL',
    CAUTION = 'CAUTION',
    DOLLAR_SIGN = 'DOLLAR_SIGN',
    PERCENT_SIGN = 'PERCENT_SIGN',
    SHIPMENT_DELIVERED = 'SHIPMENT_DELIVERED',
    STACK_BILL = 'STACK_BILL',
    DIAMOND = 'DIAMOND',
    CALENDAR = 'CALENDAR',
    DOLLAR_SIGN_WITH_CIRCLE_ARROW = 'DOLLAR_SIGN_WITH_CIRCLE_ARROW',
  }

  export type TypeType =
    | 'TYPE_UNKNOWN'
    | 'INSTRUMENT_BLOCKER'
    | 'PREPAID_CARD_BLOCKER'
    | 'PREPAID_CARD_NET_BLOCKER'
    | 'REGION_RESTRICTION'
    | 'FACE_MASK'
    | 'INSTRUMENT_MUST_BE_UPDATED'
    | 'INSIDER'
    | 'ECO_FRIENDLY_OFFSETS'
    | 'RESELLER_CERTIFICATE_REQUIRED'
    | 'FAIRE_PAY_UPSELL'
    | 'FAIRE_PAY_SAVING'
    | 'UNPAID_EXCLUSIVITY_AGREEMENT';

  export enum Type {
    TYPE_UNKNOWN = 'TYPE_UNKNOWN',
    INSTRUMENT_BLOCKER = 'INSTRUMENT_BLOCKER',
    PREPAID_CARD_BLOCKER = 'PREPAID_CARD_BLOCKER',
    PREPAID_CARD_NET_BLOCKER = 'PREPAID_CARD_NET_BLOCKER',
    REGION_RESTRICTION = 'REGION_RESTRICTION',
    FACE_MASK = 'FACE_MASK',
    INSTRUMENT_MUST_BE_UPDATED = 'INSTRUMENT_MUST_BE_UPDATED',
    INSIDER = 'INSIDER',
    ECO_FRIENDLY_OFFSETS = 'ECO_FRIENDLY_OFFSETS',
    RESELLER_CERTIFICATE_REQUIRED = 'RESELLER_CERTIFICATE_REQUIRED',
    FAIRE_PAY_UPSELL = 'FAIRE_PAY_UPSELL',
    FAIRE_PAY_SAVING = 'FAIRE_PAY_SAVING',
    UNPAID_EXCLUSIVITY_AGREEMENT = 'UNPAID_EXCLUSIVITY_AGREEMENT',
  }

  /**
   * Return an instance of IDisclaimer with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IDisclaimer>): IDisclaimer =>
    ({
      ...(partial ?? {}),
    }) as IDisclaimer;
}

export interface IDisclaimer {
  title: string | undefined;
  message: string | undefined;
  /**
   * The url where when the CTA button leads. Should be renamed to "ctaUrl"
   */
  help_link: string | undefined;
  /**
   * The text of the CTA button. Should be renamed to "ctaText"
   */
  help_text: string | undefined;
  /**
   * Whether click on the CTA button should open a new tab (false) or not (true). False by default.
   */
  cta_same_page: boolean | undefined;
  icon: keyof typeof IDisclaimer.Icon | undefined;
  text_color: string | undefined;
  background_color: string | undefined;
  border_color: string | undefined;
  /**
   * Optional. It could help differentiate disclaimers to drive its style, positioning, etc.
   * Add new styles only when absolutely needed; in most cases, type is unnecessary.
   */
  type: keyof typeof IDisclaimer.Type | undefined;
}
